import styled from 'styled-components';

export const All = styled.div`
width: 100%;
background: #F4F5F6;
height: 100%;
`;
export const Headers = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 45px;
  position: relative;
`;

export const Image = styled.img`
  width: 224px;
  height: 40px;
  object-fit: cover;
  margin-top: -8px
`;

export const Container = styled.div`
  height: 35px;
  display: flex;
  align-items: center;
  background: #ECF2FF;
  border-radius: 8px;
  border: 1px solid #FFFFFF;
`;

export const InfoDiv = styled.div`
  display: flex;
  align-items: center;
  margin-left: 10px;
`;

export const InfoItem = styled.div`
  margin-left: 25px;
  font-family: MicrosoftYaHei;
  font-size: 14px;
  color: #181818;
  line-height: 22px;
  text-align: right;
  font-style: normal;
`;

export const Name = styled.div`
  font-family: MicrosoftYaHei, MicrosoftYaHei;
  font-weight: bold;
  font-size: 20px;
  margin-left: 5px;
  color: #FFFFFF;
  line-height: 32px;
  text-align: left;
  font-style: normal;
  margin-left: 30px;
`;
export const Parameter = styled.span`
  font-family: MicrosoftYaHei, MicrosoftYaHei;
  font-weight: bold;
  font-size: 16px;
  color: #0A8CEB;
  line-height: 22px;
  text-align: left;
  font-style: normal;
`;
export const Searchs = styled.div`
  width:100%;
  height: 60px;
  background: #FFFFFF;
  border-radius: 12px;
`;
export const TabsContainer = styled.div`
  width: 100%;
  height: 390px;
  background: #FFFFFF;
  border-radius: 12px;
  margin-top: 15px;
`;
export const TableContainer = styled.div`
  width: 100%;
  height: 390px;
  margin-top: 15px;
  display: flex;
  justify-content: space-between;
`;

export const RightDiv = styled.div`
  width: calc(50% - 5px);
  background-color: #fff;
  padding: 15px 25px;
  border-radius: 12px;
  // overflow-y: auto;
`;
export const LeftDiv = styled.div`
  width: calc(50% - 5px);
  background-color: #fff;
  padding: 15px 25px;
  border-radius: 12px;
  // overflow-y: auto;
`;
export const LeftTop = styled.div`
  width: 100%;
  height: 40px;
  display: flex;
  align-items: center;
  position: relative;
`;
export const Modals = styled.div`
  width: 100%;
  height: 300px;
  position: absolute;
  top: 45px;
  left: 0;
  z-index: 999;
  border: 1px solid #d2d2d2;
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, .12);
  padding: 10px 10px 0 10px;
  position: absolute;
  z-index: 66666666;
  margin: 5px 0;
  border-radius: 2px;
  min-width: 600px;
  // overflow-y: auto;
`;
export const Title = styled.div`
  font-family: MicrosoftYaHei, MicrosoftYaHei;
  font-weight: bold;
  font-size: 20px;
  color: #2A2B2C;
  line-height: 22px;
  text-align: left;
  font-style: normal;
`;

export const HB = styled.div`
  width: 4px;
  height: 20px;
  background: #0A8CEB;
  border-radius: 2px;
  margin-right: 10px;
`;
